<template>
  <div class="iso">
    <div class="images">
      <div class="image" v-for="(item,index) in images" :key="index">
         <el-image :preview-src-list="imageSrcList" fit="contain" :src="item.url" lazy/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ISO",
  mounted() {
    this.imageSrcList = this.images.map(item=>item.url)
  },
  data(){
    return{
      images:[
        {url:require('../../assets/images/certification/iso/4ab0423bba3b0e605d3ecb783fc3890.jpg')},
        {url:require('../../assets/images/certification/iso/71a5c5fe785a97cec00ccf393b55434.jpg')},
        {url:require('../../assets/images/certification/iso/cdc0a02a719b3e8e41fda71bb87e5ea.jpg')}
      ],
      imageSrcList:[]
    }
  }
}
</script>

<style lang="less" scoped>
.iso{
  height: 320px;
  text-align: center;
  overflow: scroll;
  &::-webkit-scrollbar{
    display:none
  }
  .images {
    margin: 5px 0;
    .image {
      font-size: 28px;
      display: inline-block;
      .el-image{
        margin: 5px 20px;
        width: 216px;
      }
    }
  }
}


</style>
